// Show the first tab and hide the rest
document.addEventListener("DOMContentLoaded", function () {
  var collectionTabs = document.querySelector(".collection_tabs");
  if (collectionTabs) {
    var firstTab = document.querySelector("#tabs-nav li:first-child");
    if (firstTab) {
      firstTab.classList.add("active");
    }

    var tabContents = document.querySelectorAll(".tab-content");
    tabContents.forEach(function (tabContent) {
      tabContent.style.display = "none";
    });
    tabContents[0].style.display = "block";

    // Click function
    var tabListItems = document.querySelectorAll("#tabs-nav li");
    tabListItems.forEach(function (tabListItem) {
      tabListItem.addEventListener("click", function () {
        tabListItems.forEach(function (item) {
          item.classList.remove("active");
        });
        this.classList.add("active");

        tabContents.forEach(function (tabContent) {
          tabContent.style.display = "none";
        });

        var activeTab = this.querySelector("a").getAttribute("href");
        document.querySelector(activeTab).style.display = "block";

        return false;
      });
    });

    var tabLinks = document.querySelectorAll("#tabs-nav a");

    tabLinks.forEach(function (tabLink) {
      tabLink.addEventListener("click", function (event) {
        event.preventDefault();

        var parent = this.parentNode;
        if (parent) {
          var positionLeft = parent.offsetLeft;
          var width = parent.offsetWidth;

          var slider = document.querySelector(".tabs .slider");
          slider.style.left = positionLeft + "px";
          slider.style.width = width + "px";
        }
      });
    });

    var actWidth = document.querySelector(".tabs #tabs-nav .active").parentNode
      .offsetWidth;
    var actPosition = document.querySelector(
      ".tabs #tabs-nav .active"
    ).offsetLeft;
    var slider = document.querySelector(".tabs .slider");
    slider.style.left = actPosition + "px";
    slider.style.width = actWidth + "px";
  }

   
     
    const collectionLinks = document.querySelectorAll(".collection_filter");
    const currentUrl = window.location.href;
    
    collectionLinks.forEach(link => {
      if (link.href === currentUrl) {
        link.classList.add("visible");
      }
      
      link.addEventListener("click", function() {
        collectionLinks.forEach(l => l.classList.remove("visible"));
        this.classList.add("visible");
      });
    });

    const currentPath = window.location.pathname; // Get current URL path
    document.querySelectorAll(".m-home-menu-item").forEach((item) => {
        const itemPath = new URL(item.dataset.activeUrl, window.location.origin).pathname;
        if (currentPath === itemPath) {
            item.classList.add("active-collection"); // Add active class
            // Scroll smoothly to the active element
            item.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
        }
    });

  document.querySelectorAll(".capitalize-text").forEach((el) => {
    el.textContent = el.textContent
        .toLowerCase()
        .replace(/\b\w/g, (char) => char.toUpperCase());
    });


    // let productGrid = document.getElementById("product-grid");
    // if (!productGrid) return;

    // let productItems = Array.from(productGrid.children);

    // // Sort products by vendor
    // productItems.sort((a, b) => {
    //     let vendorA = a.querySelector(".card-product__vendor")?.innerText.trim().toLowerCase() || "";
    //     let vendorB = b.querySelector(".card-product__vendor")?.innerText.trim().toLowerCase() || "";
    //     return vendorA.localeCompare(vendorB);
    // });

    // // Append sorted items back to the grid
    // productItems.forEach(item => productGrid.appendChild(item));


  
});

